import React from 'react';
import fetch from 'isomorphic-fetch';
import _ from 'lodash'; // eslint-disable-line
import { Route, IndexRoute, IndexRedirect, browserHistory } from 'react-router';
import App from './App';
import NotFoundv2 from './pages/NotFoundv2';

import CreateFlow from './components/onboard/CreateFlow';
import SignupIntentPage from './pages/preauth/SignupIntentPage';
import SignupPageContainer from './pages/preauth/SignupPageContainer';
import LoginPageContainer from './pages/preauth/LoginPageContainer';
import ForgotPasswordPage from './pages/preauth/ForgotPasswordPage';

import ThemesContainer from './components/manage/website/ThemesContainer';
import PreauthThemesContainer from './pages/preauth/ThemesContainer';
import ThemeDetail from './components/manage/website/ThemeDetail';
import EditPage from './components/manage/website/EditPage';
import ManagePages from './components/manage/website/ManagePages';
import WeddingParty from './components/PublicWebsite/pages/WeddingParty';
import WeddingPartyV2 from './components/PublicWebsite/pages/WeddingPartyV2';
import Poi from './components/PublicWebsite/pages/Poi';
import Faq from './components/PublicWebsite/pages/Faq';
import Registry from './components/PublicWebsite/pages/Registry';
import Photos from './components/PublicWebsite/pages/Photos';
import Travel from './components/PublicWebsite/pages/Travel';
import Events from './components/PublicWebsite/pages/Events';
import Home from './components/PublicWebsite/pages/Home';
import MobileLandingPage from './components/onboard/MobileLanding/MobileLandingPage';
import Credits from './components/Credits';
import PreAuthApp from './pages/preauth/PreAuthApp';
import Directory from './components/manage/guestlist/Directory';
import Build from './components/manage/guestlist/Build';
import AddressEnvelopes from './components/manage/guestlist/AddressEnvelopes';
import RsvpOverview from './components/manage/guestlist/RsvpOverview';
import TrackRsvpNotifications from './components/manage/guestlist/trackRsvpNotifications/TrackRsvpNotifications';
import multipleRsvpNotifications from './components/manage/guestlist/trackRsvpNotifications/MultipleRsvpNotifications'; // eslint-disable-line
import AddGuestPage from './components/manage/guestlist/addGuestPage/AddGuestPage';
import RsvpEvent from './components/manage/guestlist/RsvpEvent';
import { getWeddingBySlug, getWeddingPreviewBySlug, getWeddingByHashId, getRsvpByGuestGroupUuid, getGuestRequestCount, storeMobileToken } from './actions/PublicWebsiteActions';
import { getUserContext } from './actions/UserActions';
import { fetchWeddingAccount } from './actions/WeddingActions';
import { fetchEventsRsvpPage } from './actions/EventActions';
import { fetchChart } from './actions/SeatingChartActions';
import fetchPromotion from './actions/PromotionActions';

import RsvpBase from './components/PublicWebsite/pages/RsvpBase';

import UrlContainer from './components/settings/url/UrlContainer';
import WeddingDetailsContainer from './components/settings/wedding/WeddingDetailsContainer';

import { fetchCardFullDetail, updateDetailAdminView, updateActiveProduct } from './cards/actions/cardDetailActions';
import { updateCardTypeFilter, updateCardActiveFilter, updateListingAdminView } from './cards/actions/cardListingActions';
import { fetchProject, getProjectAuthenticated } from './cards/actions/cardProjectActionsV2';

import { setCookie } from './util/storage';
import PrivacySettings from './components/settings/PrivacySettings';
// import AccountSettings from './pages/AccountSettings';
// import { THEMES_REQUESTED } from './actions/types/website/ThemeListingActionTypes';
// import { resetFacetValues } from './actions/GuestActions';

// call updateBoxShadow (which is set in web-nav) becuz if you visit a weddings page with no sub-nav (ie, web-nav has a dropshadow),
// and then navigate to a weddings page with a sub-nav, it should update web-nav to NOT have a dropshadow (and vice versa);
browserHistory.listen((location) => {
  if (location.pathname) {
    if (window.zolaNav && window.zolaNav.updateBoxShadow) {
      window.zolaNav.updateBoxShadow(location.pathname);
    }
  }
});

const getRoutes = (store) => {
  const redirect = ({ to, useSlug }) => ((nextState) => {
    const slug = useSlug ? `/${nextState.params[useSlug]}` : '';
    window.location = `${to}${slug}`;
  });

  const checkWeddingPreviewBySlug = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const slug = nextState.params.slug;
    dispatch(getWeddingPreviewBySlug(slug))
      .then(() => {
        const state = store.getState();
        if (state.publicWebsite.error) {
          replaceState('/notfound');
        }
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };

  const checkGetUser = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => callback());
  };

  const checkWeddingByHashId = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const hashId = nextState.params.hashId;
    dispatch(getWeddingByHashId(hashId))
      .then(() => {
        const state = store.getState();
        if (state.publicWebsite.error) {
          replaceState('/notfound');
        }
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };

  const checkWeddingWithToken = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const slug = nextState.params.slug;
    const token = nextState.location.query.preview_token;
    if (token) {
      dispatch(storeMobileToken(token));
      fetch('/web-api/v1/auth/mobile-website-preview',
        {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ token })
        })
        .then(() => {
          dispatch(getWeddingBySlug(slug))
            .then(() => {
              callback();
            }).catch(() => {
              replaceState('/notfound');
              callback();
            });
        }).catch(() => {
          replaceState('/notfound');
          callback();
        });
    } else {
      dispatch(getWeddingBySlug(slug))
        .then(() => {
          callback();
        })
        .catch((e) => {
          if (e.response && e.response.status === 403) {
            replaceState(`/wedding/${slug}/passcode`);
          } else {
            replaceState('/notfound');
          }
          callback();
        });
    }
  };

  const checkWeddingSlug = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const slug = nextState.params.slug;

    dispatch(getWeddingBySlug(slug))
      .then(() => {
        replaceState(`/wedding/${slug}`);
        callback();
      })
      .catch((e) => {
        if (e.response && !(e.response.status === 403)) {
          replaceState('/notfound');
        }
        callback();
      });
  };

  const checkLogin = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (!state.user.userContext || state.user.userContext.is_guest) {
          replaceState('/wedding/login');
        } else if (state.user.userContext.has_wedding_account || state.user.userContext.has_registry) {
          window.location = '/';
        }
        callback();
      }).catch(() => {
        replaceState('/wedding/login');
        callback();
      });
  };

  // Confirm a user is not logged in before displaying pre-auth onboarding routes.
  const confirmPreAuth = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext && !state.user.userContext.is_guest) {
          window.location.href = '/';
          return;
        }
        callback();
      })
      .catch(() => {
        window.location.href = '/';
      });
  };

  const checkLoginAndRedirectToReferralPage = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        // if user is guest or user is "idle" (been logged in for more than 30 minutes), then redirect them to login page
        if (!state.user.userContext || state.user.userContext.is_guest || state.user.userContext.status === 'IDLE') {
          browserHistory.push({ pathname: '/wedding/login', state: { referralPage: window.location.pathname } });
        } else if (state.user.userContext.has_wedding_account || state.user.userContext.has_registry) {
          callback();
        }
        callback();
      }).catch(() => {
        replaceState('/wedding/login');
        callback();
      });
  };

  // checks for a specific requirement and if it doesn't exist, redirects them to another page
  const checkForRequirement = requirement => (nextState, replaceState, callback) => {
    const state = store.getState();
    const slug = state.user.userContext.user_role_account_weddings[0].slug;
    const registry = state.user.userContext.has_registry;
    const wedding = state.user.userContext.has_wedding_account;
    const onboarding = state.user.userContext.has_completed_onboarding;

    if (requirement === 'slug' && !slug) {
      window.location = '/account/settings/info';
    } else if (requirement === 'registryOrWedding' && !registry && !wedding) {
      window.location = '/account/settings/info';
    } else if (requirement === 'onboarding' && !onboarding) {
      window.location = '/wedding/onboard';
    } else {
      // if doesn't meet the requirements, then call `callback` (aka send them back to the original page);
      callback();
    }
  };

  const checkWeddingAccount = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(fetchWeddingAccount())
      .then(() => {
        const state = store.getState();
        if (!state.wedding.account) {
          replaceState('/wedding-planning');
        }
        callback();
      }).catch(() => {
        replaceState('/wedding-planning');
        callback();
      });
  };

  const checkRegistry = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext.registry_ids.length > 0) {
          window.location = '/registry/dashboard';
        } else {
          callback();
        }
      }).catch(() => {
        callback();
      });
  };

  // stops a user with a wedding account from seeing /wedding/designs.
  const checkWedding = ({ redirectTo }) => (
    (nextState, replaceState, callback) => {
      const dispatch = store.dispatch;
      dispatch(getUserContext())
        .then(() => {
          const state = store.getState();
          if (state.user.userContext.has_wedding_account) {
            window.location = redirectTo;
          } else {
            callback();
          }
        }).catch(() => {
          callback();
        });
    }
  );

  const checkWeddingAccountForLP = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext.has_wedding_account) {
          replaceState('/wedding/manage');
        }
        callback();
      }).catch(() => {
        callback();
      });
  };

  const checkWeddingAccountForLP2 = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (state.user.userContext.has_wedding_account) {
          replaceState('/wedding/manage');
        } else if (!state.user.userContext.has_registry) {
          replaceState('/wedding-planning');
        }
        callback();
      }).catch(() => {
        replaceState('/wedding-planning');
        callback();
      });
  };

  const checkPromotionKey = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const { pkey } = nextState.params;
    dispatch(fetchPromotion(pkey))
      .then((promotion) => {
        const state = store.getState();
        if (promotion.business_unit === 'WEDDING_REGISTRY') {
          window.location = `/wedding-registry/promotion/${pkey}`;
        } else if (state.user.userContext.has_wedding_account) {
          window.location = ('/wedding/manage');
        } else {
          callback();
        }
      }).catch(() => {
        replaceState('/wedding');
        callback();
      });
  };

  const isOnboarding = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(fetchWeddingAccount())
      .then(() => {
        const state = store.getState();
        if (!state.wedding.account.disable_website_onboarding) {
          replaceState('/wedding/manage/website/designs');
        }
        callback();
      }).catch(() => {
        replaceState('/wedding');
        callback();
      });
  };

  const checkEvent = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const { eventUUID } = nextState.params;
    dispatch(fetchEventsRsvpPage())
      .then(() => {
        const { events } = store.getState().events;
        const eventId = events.uuidToId[eventUUID];
        if (!eventId) {
          replaceState('/wedding/manage/guests/rsvps/overview');
        }
        callback();
      })
      .catch(() => {
        replaceState('/wedding/manage/guests/rsvps/overview');
        callback();
      });
  };

  const checkGuestRequests = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getGuestRequestCount())
      .then(() => getGuestRequestCount())
      .then(() => {
        const notificationCount = store.getState().publicWebsite.guestRequestCount;
        if (notificationCount === 0) {
          replaceState('/wedding/manage/guests/all');
        }
        callback();
      })
      .catch(() => {
        replaceState('/wedding/manage/guests/all');
        callback();
      });
  };

  // onEnter hook  used for customization flow
  const onEnterCustomizationFlowV2 = (nextState, replaceState, callback) => {
    const { projectUUID } = nextState.params;
    const dispatch = store.dispatch;
    const paths = nextState.location.pathname.split('/'); // eslint-disable-line
    const state = store.getState();

    if (state.user.hasIdentified && state.user.userContext.has_invitation_account) {
      dispatch(fetchWeddingAccount());
      dispatch(getProjectAuthenticated(projectUUID))
        .then((ownsProject) => {
          if (!ownsProject) {
            replaceState('/wedding-planning/');
            callback();
          }
        });
    } else {
      replaceState('/wedding-planning/invites-paper/');
      // use below post New LP launches
      // replaceState('/wedding-planning/paper/');
      callback();
      return;
    }
    // v2 customization flow
    // console.log(state.cards.cardProject.projectUUID, projectUUID);
    if (state.cards.cardProject.projectUUID && state.cards.cardProject.projectUUID === projectUUID) { // eslint-disable-line
      callback();
    } else {
      dispatch(fetchProject(projectUUID)).then(() => {
        callback();
      });
    }
  };

  // onEnter hook used for customization steps
  const onEnterCustomizationStepV2 = (nextState, replaceState, callback) => { // eslint-disable-line
    const { projectUUID } = nextState.params; // eslint-disable-line
    const { dispatch } = store; // eslint-disable-line

    const { steps } = store.getState().cards.cardProject;
    const paths = nextState.location.pathname.split('/');
    const step = paths[paths.length - 1];
    if (steps[step]) {
      callback();
    } else {
      replaceState(`/wedding-planning/custom/${projectUUID}`);
      callback();
    }
    // callback();
    // sharedPrepareSubPage(dispatch, paths, nextState, replaceState, callback);
  };

  // Fetch seating chart by uuid
  const fetchSeatingChart = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const uuid = nextState.params.uuid;
    dispatch(fetchChart(uuid))
      .then(() => {
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };


  const gotoInvitations = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(updateCardTypeFilter('INVITATION'));
    dispatch(updateCardActiveFilter(true));
    dispatch(updateListingAdminView(false));
    callback();
    // dispatch(selectEventTypeAsync('invitation'))
    //   .then(() => {
    //     callback();
    //   });
  };

  const gotoSaveTheDates = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(updateCardTypeFilter('SAVE_THE_DATE'));
    dispatch(updateCardActiveFilter(true));
    dispatch(updateListingAdminView(false));
    callback();
    // dispatch(selectEventTypeAsync('std'))
    //   .then(() => {
    //     callback();
    //   });
  };

  const gotoPrivateInvitations = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(updateCardTypeFilter('INVITATION'));
    dispatch(updateCardActiveFilter(false));
    dispatch(updateListingAdminView(true));
    callback();
    // dispatch(selectEventTypeAsync('invitation'))
    //   .then(() => {
    //     callback();
    //   });
  };

  const gotoPrivateSaveTheDates = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(updateCardTypeFilter('SAVE_THE_DATE'));
    dispatch(updateCardActiveFilter(false));
    dispatch(updateListingAdminView(true));
    callback();
    // dispatch(selectEventTypeAsync('std'))
    //   .then(() => {
    //     callback();
    //   });
  };

  const gotoOrder = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    dispatch(getUserContext())
      .then(() => {
        const state = store.getState();
        if (!state.user.userContext || state.user.userContext.is_guest || !state.user.userContext.has_invitation_account) {
          replaceState('/notfound');
        }
        callback();
      }).catch(() => {
        replaceState('/notfound');
        callback();
      });
  };

  const gotoPDP = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const { productUUID } = nextState.params; // productType
    // const paths = nextState.location.pathname.split('/');
    // const productType = paths[paths.length - 2];
    // const activeCardEvent = (productType === 'invitations' ? 'invitation' : 'std');
    if (store.getState().cards.cardDetail.products[productUUID]) {
      dispatch(updateActiveProduct(productUUID));
      callback();
    } else {
      dispatch(fetchCardFullDetail(productUUID))
        .then(() => {
          // dispatch(setProductId(productUUID));
          // dispatch(updateDetailAdminView(false));
          // dispatch(selectEventType(activeCardEvent));
          callback();
        })
        .catch(() => {
          replaceState('/notfound');
          callback();
        });
    }
  };

  const gotoPrivatePDP = (nextState, replaceState, callback) => {
    const dispatch = store.dispatch;
    const { productUUID } = nextState.params;
    // const paths = nextState.location.pathname.split('/');
    // const productType = paths[paths.length - 2];
    // const activeCardEvent = (productType === 'invitations' ? 'invitation' : 'std');

    // pass true to fetch admin view
    dispatch(fetchCardFullDetail(productUUID, true))
      .then(() => {
        // dispatch(setProductId(productUUID));
        dispatch(updateDetailAdminView(true));
        // dispatch(selectEventType(activeCardEvent));
        callback();
      })
      .catch(() => {
        replaceState('/notfound');
        callback();
      });
  };

  const checkGuestByUUID = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const nextParams = nextState.params;
    const { slug, uuid } = nextParams;
    if (uuid) {
      dispatch(getRsvpByGuestGroupUuid(uuid))
        .then(() => {
          callback();
        })
        .catch(() => {
          replaceState(`/wedding/${slug}/rsvp`);
          callback();
        });
    } else {
      replaceState(`/wedding/${slug}/rsvp`);
      callback();
    }
  };

  const checkProject = (nextState, replaceState, callback) => {
    const { dispatch } = store;
    const { projectUUID } = nextState.params;
    dispatch(fetchProject(projectUUID))
      .then(() => {
        // dispatch(fetchProjectOrder(projectUUID));
        callback();
      })
      .catch(() => {
        replaceState('/wedding-planning/projects/finished');
        callback();
      });
  };

  const setInvitesPaperCookie = (nextState, replaceState, callback) => {
    setCookie('invitesAlpha', true, 7);
    callback();
  };

  return (
    <Route component={App} onEnter={checkGetUser}>
      <Route
        path="addr/:hashId"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./components/collectAddress/').default);
          }, 'CollectAddresses');
        }}
        onEnter={checkWeddingByHashId}
      />
      <Route
        path="address/:slug"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./components/collectAddress/').default);
          }, 'CollectAddresses');
        }}
        onEnter={checkWeddingPreviewBySlug}
      />
      {/* OLD INVITES-PAPER ROUTES */}
      <Route  // old
        path="/wedding-planning/invites-paper"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default);  // Cards
          }, 'Cards');
        }}
        onEnter={setInvitesPaperCookie}
      >
        <IndexRedirect to="save-the-date" />
        <Route  // old
          path="invitations"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardListing').default);
            }, 'CardListing');
          }}
          onEnter={gotoInvitations}
        />
        <Route  // old
          path="invitations/:productUUID"  // pdp page // :productType should be refactored to more explicit
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardDetail').default);
            }, 'CardDetail');
          }}
          onEnter={gotoPDP}
        />
        <Route  // old
          path="save-the-date"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardListing').default);
            }, 'CardListing');
          }}
          onEnter={gotoSaveTheDates}
        />
        <Route  // old
          path="save-the-date/:productUUID"  // pdp page // :productType should be refactored to more explicit
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardDetail').default);
            }, 'CardDetail');
          }}
          onEnter={gotoPDP}
        />
      </Route>
      {/* END --- OLD INVITES-PAPER ROUTES */}
      {/* WEDDING  */}
      <Route
        path="/wedding-planning"
        onEnter={checkGetUser}
        component={PreAuthApp}
      >
        <IndexRoute
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/Planning').default);
            }, 'Planning');
          }}
          onEnter={checkWeddingAccountForLP}  // TODO: needs to combine setInvitesPaperCookie
        />
        <Route
          path="website" onEnter={checkWedding({ redirectTo: '/wedding/manage/website' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/Website').default);
            }, 'Website');
          }}
        />
        <Route
          path="website/designs" onEnter={checkWedding({ redirectTo: '/wedding/manage/website/designs' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/Themes').default);
            }, 'Themes');
          }}
          component={PreauthThemesContainer}
        />
        <Route
          path="website/design/:themeKey" onEnter={checkWedding({ redirectTo: '/wedding/manage/website/designs' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/ThemeDetail').default);
            }, 'ThemeDetail');
          }}
        />
        <Route
          path="checklist" onEnter={checkWedding({ redirectTo: '/wedding/manage/checklist' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/Checklist').default);
            }, 'Checklist');
          }}
        />
        <Route
          path="guests" onEnter={checkWedding({ redirectTo: '/wedding/manage/guests/all' })}
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/GuestList').default);
            }, 'GuestList');
          }}
        />
        {/* NEW SEATING CHART LANDING  */}
        {/* NEW INVITATION PAPER LANDING  */}
        <Route
          path="paper"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/HomeJoint').default);  // Invitation Joint std and invitation pre-auth landing page
            }, 'HomeJoint');
          }}
          // onEnter={setInvitesPaperCookie}
        />
        {/* END --- INVITATION PAPER LANDING  */}
        {/* NEW INVITATION LANDING  */}
        <Route
          path="invitations"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/HomeInvitation').default);
            }, 'HomeInvitation');
          }}
        />
        {/* END --- NEW INVITATION LANDING */}
        {/* NEW SAVE-THE-DATE LANDING  */}
        <Route
          path="save-the-date"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/preauth/HomeSaveTheDate').default);
            }, 'HomeSaveTheDate');
          }}
        />
        {/* END --- NEW SAVE-THE-DATE LANDING */}
      </Route>
      {/* END --- WEDDING */}
      <Route
        path="/wedding-planning"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default);  // Cards
          }, 'Cards');
        }}
        onEnter={setInvitesPaperCookie}
      >
        {/* PROJECT */}
        <Route
          path="projects"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardProjects').default);
            }, 'CardProjects');
          }}
        >
          <IndexRedirect to="drafts" />
          <Route
            path="drafts"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/ProjectDrafts/ProjectDraftsContainerV2').default);
              }, 'ProjectDraftsV2');
            }}
            onEnter={gotoOrder}
          />
          <Route
            path="finished"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/ProjectOrders/ProjectOrdersContainerV2').default);
              }, 'ProjectOrdersV2');
            }}
            onEnter={gotoOrder}
          />
          {/* )} */}
        </Route>
        {/* END -- PROJECT */}

        {/* VIEW ORDER */}
        <Route
          path="/wedding-planning/view_order"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/ViewOrder').default);
            }, 'ViewOrder');
          }}
        >
          <Route
            path=":projectUUID"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/common/ViewOrderGallery/ViewOrderGallery').default);
              }, 'ViewOrderGallery');
            }}
            onEnter={checkProject}
          />
        </Route>
        {/* END -- VIEW ORDER */}

        {/* Start -- V2 Customization flow routes */}
        <Route
          path="custom/:projectUUID"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardCustomizationFlowV2').default);
            }, 'CardCustomizationFlowV2');
          }}
          onEnter={onEnterCustomizationFlowV2}
        >
          <Route
            path="detailFront"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/EventDetailFrontV2').default);
              }, 'EventDetailFrontV2');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="detailBack"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/EventDetailBackV2').default);
              }, 'EventDetailBackV2');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="rsvp"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/RSVPV2').default);
              }, 'RSVPV2');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="rsvpEnvelope"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/RSVPEnvelopeV2').default);
              }, 'RsvpEnvelopeV2');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="envelope"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/EnvelopeV2').default);
              }, 'EnvelopeV2');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="recipients"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Recipients/RecipientsV2').default);
              }, 'Recipients');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="addressing"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Addressing/AddressingV2').default);
              }, 'Addressing');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
          <Route
            path="reviewPaper"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./cards/components/CustomizationV2/steps/Review').default);
              }, 'Review');
            }}
            onEnter={onEnterCustomizationStepV2}
          />
        </Route>
      </Route>

      {/* NEW Invitation/save-the-date ROOT ROUTE */}
      <Route
        path="/wedding-planning/invitations"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default);
          }, 'Cards');
        }}
        onEnter={setInvitesPaperCookie}
      >
        {/* Invitation pre-auth Home Page */}
        <IndexRedirect to="./" />
        <Route
          path="shop"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardListing').default);  // Invitation PLP
            }, 'CardListing');
          }}
          onEnter={gotoInvitations}
        />
        <Route  // old :productType/:productUUID
          path=":productUUID"  // pdp page // :productType should be refactored to more explicit
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardDetail').default);
            }, 'CardDetail');
          }}
          onEnter={gotoPDP}
        />
      </Route>
      <Route
        path="/wedding-planning/save-the-date"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default);
          }, 'Cards');
        }}
        onEnter={setInvitesPaperCookie}
      >
        {/* save-the-date pre-auth Home Page */}
        <IndexRedirect to="./" />
        <Route
          path="shop"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardListing').default);  // STD PLP
            }, 'CardListing');
          }}
          onEnter={gotoSaveTheDates}
        />
        <Route  // old :productType/:productUUID
          path=":productUUID"  // pdp page // :productType should be refactored to more explicit
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardDetail').default);
            }, 'CardDetail');
          }}
          onEnter={gotoPDP}
        />
      </Route>

      {/* Invitation Admin Routes */}
      <Route
        path="/wedding-planning/admin/invitations"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default);
          }, 'Cards');
        }}
        onEnter={setInvitesPaperCookie}
      >
        {/* Invitation pre-auth Home Page */}
        <IndexRedirect to="./" />
        <Route
          path="shop"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardListing').default);  // Invitation PLP
            }, 'CardListing');
          }}
          onEnter={gotoPrivateInvitations}
        />
        <Route  // old :productType/:productUUID
          path=":productUUID"  // pdp page // :productType should be refactored to more explicit
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardDetail').default);
            }, 'CardDetail');
          }}
          onEnter={gotoPrivatePDP}
        />
      </Route>

      {/* STD Admin Routes */}
      <Route
        path="/wedding-planning/admin/save-the-date"
        getComponent={(location, callback) => {
          require.ensure([], (require) => {
            callback(null, require('./cards/pages/Cards').default);
          }, 'Cards');
        }}
        onEnter={setInvitesPaperCookie}
      >
        {/* save-the-date pre-auth Home Page */}
        <IndexRedirect to="./" />
        <Route
          path="shop"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardListing').default);  // STD PLP
            }, 'CardListing');
          }}
          onEnter={gotoPrivateSaveTheDates}
        />
        <Route  // old :productType/:productUUID
          path=":productUUID"  // pdp page // :productType should be refactored to more explicit
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./cards/pages/CardDetail').default);
            }, 'CardDetail');
          }}
          onEnter={gotoPrivatePDP}
        />
      </Route>
      {/* END --- NEW Invitation/save-the-date ROOT ROUTE */}
      {/* Preauth onboarding pages */}
      <Route path="/onboard" >
        <Route path="signup" component={SignupPageContainer} onEnter={confirmPreAuth} />
        <Route path="login" component={LoginPageContainer} onEnter={confirmPreAuth} />
        <Route path="forgot" component={ForgotPasswordPage} onEnter={confirmPreAuth} />
        <Route path="select-product" component={SignupIntentPage} onEnter={confirmPreAuth} />
        <IndexRedirect to="select-product" component={SignupIntentPage} />
      </Route>
      <Route path="/wedding" onEnter={checkGetUser}>
        <IndexRedirect to="/wedding-planning" />
        <Route
          path="mobile-landing"
          component={MobileLandingPage}
        />
        <Route
          path="guest-help"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/GuestHelp').default);
            }, 'GuestHelp');
          }}
        />
        <Route
          path="help"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/WeddingHelpPublic').default);
            }, 'WeddingHelpPublic');
          }}
        />
        <Route component={PreAuthApp}>
          <Route
            path="from-registry"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/preauth/Planning').default);
              }, 'WeddingsLP');
            }}
            onEnter={checkWeddingAccountForLP2}
          />
          <Route
            path="promotion/:pkey"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/preauth/Planning').default);
              }, 'Promotion');
            }}
            onEnter={checkPromotionKey}
          />
          <Route
            path="promotional/:pkey"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/preauth/Planning').default);
              }, 'Promotional');
            }}
            onEnter={checkPromotionKey}
          />
        </Route>
        <Route
          path="login"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Login').default);
            }, 'Login');
          }}
        />
        <Route
          path="onboard"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./components/onboard').default);
            }, 'Onboard');
          }}
          onEnter={checkLogin}
        >
          <IndexRoute component={CreateFlow} />
        </Route>
        <Route
          path="onboard/:selectedThemeId"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./components/onboard').default);
            }, 'Onboard');
          }}
          onEnter={checkLogin}
        >
          <IndexRoute component={CreateFlow} />
        </Route>
        <Route
          path="manage"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Manage').default);
            }, 'Manage');
          }}
          onEnter={checkWeddingAccount}
        >
          <IndexRoute
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Dashboard').default);
              }, 'Dashboard');
            }}
            onEnter={checkGetUser}
          />
          <Route
            path="feed"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/manage/feed/Feed').default);
              }, 'Feed');
            }}
          />
          <Route
            path="events"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Events').default);
              }, 'Events');
            }}
          />
          <Route
            path="checklist"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Checklist').default);
              }, 'Checklist');
            }}
          />
          <Route
            path="registry"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/onboard/RegistryOnboard').default);
              }, 'Registry');
            }}
            onEnter={checkRegistry}
          />
          <Route
            path="registry-onboard"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./components/onboard/RegistryOnboard').default);
              }, 'Registry');
            }}
            onEnter={checkRegistry}
          />
          <Route
            path="guests"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Guests').default);
              }, 'Guests');
            }}
          >
            <IndexRedirect to="all" />
            <Route path="all" component={Directory} />
            <Route path="build" component={Build} />
            <Route path="envelopes" component={AddressEnvelopes} />
            <Route>
              <Route path="rsvp-notification/:rsvpUUID" component={TrackRsvpNotifications} onEnter={checkGuestRequests} />
              <Route path="rsvp-notifications" component={multipleRsvpNotifications} />
              <Route path="add-guest/:rsvpUUID" component={AddGuestPage} />
            </Route>
            <Route
              path="rsvps"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./components/manage/guestlist/TrackRsvpsContainer').default);
                }, 'TrackRsvpsContainer');
              }}
            >
              <IndexRedirect to="overview" />
              <Route path="overview" component={RsvpOverview} />
              <Route path=":eventUUID" component={RsvpEvent} onEnter={checkEvent} />
            </Route>
            <Route path="thank-you-notes" />
          </Route>
          {
            window.zola.env !== 'production' &&
            <Route
              path="seating-chart/:uuid"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./pages/SeatingChart').default);
                }, 'SeatingChart');
              }}
              onEnter={fetchSeatingChart}
            />
          }
          {/* Wedding Customization - WEDDINGS-1417 */}
          {window.zola.env === 'development' ? (
            <Route
              path="website"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./pages/Website').default);
                }, 'Website');
              }}
            >
              <IndexRedirect to="manage" />
              <Route
                path="pages"
                onEnter={isOnboarding}
                getComponent={(location, callback) => {
                  require.ensure([], (require) => {
                    callback(null, require('./components/manage/website/PagesV2').default);
                  }, 'Pages');
                }}
              >
                <IndexRedirect to="home" />
                <Route path=":pageKey" component={EditPage} />
              </Route>
              <Route path="manage" onEnter={isOnboarding} component={ManagePages} />
              <Route
                path="themes"
                onEnter={redirect({ to: '/wedding/manage/website/designs' })}
                component={ThemesContainer}
              />
              <Route
                path="theme/:themeKey"
                onEnter={redirect({ to: '/wedding/manage/website/design', useSlug: 'themeKey' })}
              />
              <Route path="designs" component={ThemesContainer} />
              <Route path="design/:themeKey" component={ThemeDetail} />
            </Route>
          ) : (
            <Route
              path="website"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./pages/Website').default);
                }, 'Website');
              }}
            >
              <IndexRedirect to="manage" />
              <Route
                path="pages"
                onEnter={isOnboarding}
                getComponent={(location, callback) => {
                  require.ensure([], (require) => {
                    callback(null, require('./components/manage/website/Pages').default);
                  }, 'Pages');
                }}
              >
                <IndexRedirect to="home" />
                <Route path=":pageKey" component={EditPage} />
              </Route>
              <Route path="manage" onEnter={isOnboarding} component={ManagePages} />
              <Route
                path="themes"
                onEnter={redirect({ to: '/wedding/manage/website/designs' })}
                component={ThemesContainer}
              />
              <Route
                path="theme/:themeKey"
                onEnter={redirect({ to: '/wedding/manage/website/design', useSlug: 'themeKey' })}
              />
              <Route path="designs" component={ThemesContainer} />
              <Route path="design/:themeKey" component={ThemeDetail} />
            </Route>
          )}
          <Route
            path="help"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/WeddingHelp').default);
              }, 'WeddingHelp');
            }}
          />
        </Route>
        <Route path="credits" component={Credits} />

        <Route
          path=":slug/passcode"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/Passcode').default);
            }, 'Passcode');
          }}
          onEnter={checkWeddingSlug}
        />
        {/* featured out for customized header a/b test */}
        {window.zola.env !== 'production' ? (
          <Route
            path=":slug"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Public').default);
              }, 'Public');
            }}
            onEnter={checkWeddingWithToken}
          >
            <IndexRoute component={Home} />
            <Route path="event" component={Events} />
            <Route path="faq" component={Faq} />
            <Route path="wedding_party" component={WeddingPartyV2} />
            <Route path="registry" component={Registry} />
            <Route path="poi" component={Poi} />
            <Route path="photo" component={Photos} />
            <Route path="travel" component={Travel} />
            <Route
              path="rsvp"
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./components/PublicWebsite/pages/RsvpBase').default);
                }, 'RsvpBase');
              }}
            >
              <Route path=":uuid" component={RsvpBase} onEnter={checkGuestByUUID} />
            </Route>
          </Route>
        ) : (
          <Route
            path=":slug"
            getComponent={(location, callback) => {
              require.ensure([], (require) => {
                callback(null, require('./pages/Public').default);
              }, 'Public');
            }}
            onEnter={checkWeddingWithToken}
          >
            <IndexRoute component={Home} />
            <Route path="event" component={Events} />
            <Route path="faq" component={Faq} />
            <Route path="wedding_party" component={WeddingParty} />
            <Route path="registry" component={Registry} />
            <Route path="poi" component={Poi} />
            <Route path="photo" component={Photos} />
            <Route path="travel" component={Travel} />
            <Route
              path="rsvp"
              // component={RsvpBase}
              getComponent={(location, callback) => {
                require.ensure([], (require) => {
                  callback(null, require('./components/PublicWebsite/pages/RsvpBase').default);
                }, 'RsvpBase');
              }}
            >
              <Route path=":uuid" component={RsvpBase} onEnter={checkGuestByUUID} />
            </Route>
          </Route>
        )}
        <Route path="/notfound" component={NotFoundv2} />
        <Route path="*" component={NotFoundv2} />
      </Route>
      {/* START --- new account pages */}
      <Route path="/account" onEnter={checkLoginAndRedirectToReferralPage}>
        <Route
          path="settings"
          getComponent={(location, callback) => {
            require.ensure([], (require) => {
              callback(null, require('./pages/AccountSettings').default);
            }, 'AccountSettings');
          }}
          onEnter={checkGetUser}
        >
          <Route
            path="urls"
            component={UrlContainer}
            onEnter={checkForRequirement('slug')}
          />
          <Route
            path="wedding"
            component={WeddingDetailsContainer}
            onEnter={checkForRequirement('onboarding')}
          />
          <Route
            path="privacy"
            component={PrivacySettings}
            onEnter={checkForRequirement('registryOrWedding')}
          />
        </Route>
      </Route>
    </Route>
  );
};

export default getRoutes;



/** WEBPACK FOOTER **
 ** ./src/routes.jsx
 **/